export const getNewProgramCardDetails = ({
  programIngo = false,
  journeyProgram = false,
  program,
  featuredIncludesList,
  extraOptions = {}
}) => {
  return {
    mainContainerClass: `relative w-full h-72 sm:h-auto flex flex-col justify-between bg-cover bg-center rounded-t-[5px] sm:rounded-md  overflow-hidden mb-10  bg-black-lighter border-2 hover:border-4 hover:border-yellow-standard dark:hover:border-gray-ingo hover:shadow-md`,
    cardbodyClass: `hidden sm:flex flex-col h-auto sm:px-10 py-8 rounded-b bg-black-lighter dark:md:gvi-dark-gray-bg`,
    programTypeClass: `${journeyProgram ? "bg-red-light dark:bg-green-standard" : "bg-black-lighter dark:bg-gray-darker"} text-xs text-center uppercase px-2 pt-2 pb-2 text-white`,
    programTitleClass: `ww-program-title text-xl leading-6 font-alice dark:font-body dark:font-normal text-white`,
    runByTextClass: `text-xs font-bold font-body text-white`,
    itemTextClass: "text-yellow-light",
    durationClass: `text-gray-generic pr-2 sm:pr-0 text-yellow-light dark:text-gray-generic`,
    priceClass: `font-body font-normal sm:text-base text-white`,
    extraButtonStyle: `w-full sm:w-44 sm:h-[38px] border text-white border-white !bg-transparent`,
    labelClass: `pr-2 text-white`,
    arrowClass: `h-3 w-3 stroke-white`,
    program: program,
    descWidth: "w-full",
    ctaApplyLabel: "Apply",
    ctaViewLabel: "View program",
    cardClickable: false,
    buttonStyle: "flex w-full",
    isProgramFocusPage: true,
    featuredIncludes: featuredIncludesList,
    ...extraOptions
  };
};
